import Dialog from 'components/common/Dialog/Dialog';
import TraceDetails from '../TraceDetails/TraceDetails';

function SearchTracesPage(): JSX.Element {
  return  (
    <Dialog close={(): void => {}} show size="lg" title="Inspect Trace">
      <TraceDetails />
    </Dialog>
  );
}

export default SearchTracesPage;
